export default __webpack_public_path__ + "static/ThreeQuarterXL-fe88195021a4c715b2be1e90e7faf0b1.svg";